exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element_filter[data-v-70bfa256] {\n  display: flex;\n  gap: 0 70px;\n  padding-bottom: 12px;\n}\n", ""]);

// exports
